import { render } from "./CreateGroupPermission.vue?vue&type=template&id=490d018e"
import script from "./CreateGroupPermission.vue?vue&type=script&lang=js"
export * from "./CreateGroupPermission.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__